var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "container-rules" }, [
    _c(
      "div",
      {
        staticClass: "custom-nav-block",
        style: `paddingTop:${_vm.barHeight}px`,
      },
      [
        _c("van-nav-bar", {
          staticClass: "van-bar",
          attrs: { title: "", "left-arrow": "" },
          on: { "click-left": _vm.goBack },
          scopedSlots: _vm._u([
            {
              key: "left",
              fn: function () {
                return [
                  _c("img", {
                    staticClass: "left-nav",
                    attrs: {
                      src: require("@/assets/packageAssets/common/arrow05.png"),
                      alt: "",
                    },
                  }),
                  _c("span", { staticClass: "tit-left" }, [
                    _vm._v(_vm._s(_vm.$t("lang.call.tit1"))),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        }),
      ],
      1
    ),
    _c("div", { staticClass: "main right-read" }, [
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("lang.call.tit1"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callWarning"))),
      ]),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRules"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule1"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule2"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule3"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule4"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule5"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule6"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule7"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule8"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule9"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule10"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule11"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule12"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.callRule13"))),
      ]),
      _c("br"),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.chatRules"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.chatWarning"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.chatRules1"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.chatRules2"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.chatRules3"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.chatRules4"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.chatRules5"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.chatRules6"))),
      ]),
      _c("br"),
      _c("div", { staticClass: "title" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.accountRules"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.call.conTit3"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.accountRules1"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.accountRules2"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.accountRules3"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.accountRules4"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.accountRules5"))),
      ]),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.accountRules6"))),
      ]),
      _c("br"),
      _c("div", { staticClass: "text1" }, [
        _vm._v(_vm._s(_vm.$t("lang.rule.endText"))),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }